import {
  TReceivedInvoiceCondition,
  TSetupConditionProps,
} from '@/context/services/invoice/type';
import { useReceivedInvoiceReconciliationStatusOptions } from '@/features/invoices/hooks/useReceivedInvoiceReconciliationStatusOptions';
import { useTranslation } from '@/i18n';
import { FormSelect, SelectProps } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export const ReconciliationStatus: FC<TSetupConditionProps> = memo(
  ({ control, name }) => {
    const { t } = useTranslation();
    const options = useReceivedInvoiceReconciliationStatusOptions();
    const selectProps: SelectProps = useMemo(
      () => ({
        options: options,
        mode: 'multiple',
        selectAll: false,
        maxTagCount: 1,
      }),
      [options]
    );
    const labelProps = useMemo(
      () => ({
        text: t('received_invoice_reconciliation'),
      }),
      [t]
    );

    return (
      <FormSelect<TReceivedInvoiceCondition>
        control={control}
        name={name}
        selectProps={selectProps}
        label={labelProps}
        inputId='invoice-search-reconciliation-status'
        testId='invoice-search-reconciliation-status'
      />
    );
  }
);
ReconciliationStatus.displayName = 'ReconciliationStatus';
